import React from 'react';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import Option from '../../Cell/Option';

import IntlMessage from '../../../LocaleEngine';

export default function ListOptions(props) {
    if(!props.list){
        return <IntlMessage id="activities.list.options.no_options_available" />;
    }

    if(props.list && props.list.length <= 0){
        return <IntlMessage id="activities.list.options.no_options_available" />;
    }

    const addToCart = (element, amount, callback) => {
        props.addToCart(element, amount, callback)
    }

    const Price = (a, b) => {
        if (a.Price < b.Price) {
            return -1;
        }
        if (a.Price > b.Price) {
            return 1;
        }
        return 0;
    }


    const DisplaySeq = (a, b) => {
        if (a.DisplaySeq < b.DisplaySeq) {
            return -1;
        }
        if (a.DisplaySeq > b.DisplaySeq) {
            return 1;
        }
        return 0;
    }

    const SortRank = (a, b) => {
        if (a.SortRank < b.SortRank) {
            return -1;
        }
        if (a.SortRank > b.SortRank) {
            return 1;
        }
        return 0;
    }

    const AZ = (a, b) => {
        if (a.ProductName < b.ProductName) {
            return -1;
        }
        if (a.ProductName > b.ProductName) {
            return 1;
        }
        return 0;
    }
    const internalOrder = (list, order) => {
        switch(order){
            case 'A-Z':
                list.sort(AZ)
            break;
            case 'Price':
                list.sort(Price)
            break;
            case 'DisplaySeq':
                list.sort(DisplaySeq)
            break;
            case 'SortRank':
                list.sort(SortRank)
            break;
            default:
                list.sort(Price)
            break;
        }
        return list
    }

    let orderedList = props.configuration ? internalOrder(props.list, props.configuration.config.defaultItemSort) : props.list
    return (
        <Grid container spacing={0} className="options">
            <div className="headers">
                <h4 className="title">
                    <IntlMessage id="activities.cell.option.head.product" />
                </h4>
                {props.compact ? null : <h4 className="date">
                    <IntlMessage id="activities.cell.option.head.date" />
                </h4>}
                <h4 className="amount">
                    <IntlMessage id="activities.cell.option.head.qty" />
                </h4>
                <h4 className="price">
                    <IntlMessage id="activities.cell.option.head.price" />
                </h4>
            </div>
            <div className="values">
                {
                    orderedList.map((element, index) => {
                        let isLast = false;
                        if((index+1) === props.list.length) isLast = true;

                        return (
                            <React.Fragment key={index}>
                                <Option configuration={props.configuration} maxQuantity={props.maxQuantity} dateOfActivity={props.dateOfActivity} isPackage={props.isPackage} displayType={props.displayType} compact={props.compact} addToCart={addToCart.bind(this)} date={true} element={element}/>
                                {!isLast && <Divider />}
                            </React.Fragment>
                        );
                    })
                }
            </div>
        </Grid>
    )
}
